// To indicate custom styling, the WTI translation should place text between two asterisks:
// eg. '*TEXT TO STYLE* followed by some normal text'
const CUSTOM_STYLING_MARKER = '*';
const CUSTOM_STYLING_MARKER_REGEX = new RegExp(`\\${CUSTOM_STYLING_MARKER}(.*)\\${CUSTOM_STYLING_MARKER}`);
export const CUSTOM_STYLING_REGEX = new RegExp(`(\\${CUSTOM_STYLING_MARKER}.[^*]*\\${CUSTOM_STYLING_MARKER})`, 'g');

// Splits text into an array of parts with custom vs normal styling eg. ['Some ', '*custom styled*', ' text']
export const splitTextByCustomStyling = (text: string): string[] => text.split(CUSTOM_STYLING_REGEX).filter(Boolean);

export const containsCustomStyling = (text: string): boolean => CUSTOM_STYLING_REGEX.test(text);

// Removes styling markers from the text: Input --> '*some text*', Output --> 'some text'
export const removeCustomStylingMarkers = (text: string): string | null => text.match(CUSTOM_STYLING_MARKER_REGEX)[1];
